import {createContext} from 'react';

import {SupportedLocale} from '@/initializers/i18next';
import {FullDocument, FullDocumentReadyForSignature} from '@/interfaces/document';
import {Allocation} from '@/repositories/beneva-api/endpoints/allocations';
import {Attachment} from '@/repositories/beneva-api/endpoints/attachments';

export type DocumentRepositoryContextType = {
  document: FullDocument;
  allocations: Allocation[];
  attachments: Attachment[];
  isSaving: boolean;
  hasSavingError: boolean;
  isSubmitting: boolean;
  saveDocument: (updatedDocument: Partial<FullDocument>) => Promise<void>;
  removeDocumentAttachment: (attachmentId: string) => Promise<void>;
  submitDocumentForSignature: (fullDocument: FullDocumentReadyForSignature, locale: SupportedLocale) => Promise<void>;
  resubmitDocumentForSignature: (
    fullDocument: FullDocumentReadyForSignature,
    updatedDocument: FullDocument,
  ) => Promise<void>;
};

export const DocumentRepositoryContext = createContext<DocumentRepositoryContextType | null>(null);
